import type { ModelMappingPrice, ModelProviderMapping, ProviderCatalog, ProviderChannel, ProviderMappingCatalog } from "../../api/types";

// routeEligibilitySummary keeps the Provider console and model detail reasons identical.
// 统一 Provider 控制台与模型详情页的路由可调度原因。
export function routeEligibilitySummary(
  provider: ProviderCatalog | undefined,
  channel: ProviderChannel | undefined,
  mapping: ModelProviderMapping,
  prices: ModelMappingPrice[],
  credential: ProviderMappingCatalog["credentials"][number] | undefined,
) {
  const reasons = routeEligibilityReasons(provider, channel, mapping, prices, credential);
  return reasons.length ? reasons.join("，") : "具备调度条件";
}

export function isRouteEligible(
  provider: ProviderCatalog | undefined,
  channel: ProviderChannel | undefined,
  mapping: ModelProviderMapping,
  prices: ModelMappingPrice[],
  credential: ProviderMappingCatalog["credentials"][number] | undefined,
) {
  return routeEligibilityReasons(provider, channel, mapping, prices, credential).length === 0;
}

export function groupActiveMappingPrices(prices: ModelMappingPrice[], now = Math.floor(Date.now() / 1000)) {
  const result = new Map<number, ModelMappingPrice[]>();
  prices
    .filter((price) => price.status === "enabled" && price.effective_from <= now && (price.effective_to === 0 || price.effective_to > now))
    .forEach((price) => result.set(price.mapping_id, [...(result.get(price.mapping_id) || []), price]));
  return result;
}

function routeEligibilityReasons(
  provider: ProviderCatalog | undefined,
  channel: ProviderChannel | undefined,
  mapping: ModelProviderMapping,
  prices: ModelMappingPrice[],
  credential: ProviderMappingCatalog["credentials"][number] | undefined,
) {
  const reasons: string[] = [];
  if (mapping.status !== "enabled") reasons.push("渠道模型未发布");
  if (!provider || provider.status !== "enabled") reasons.push("上游服务未发布");
  if (!channel || channel.status !== "enabled") reasons.push("渠道未发布");
  if (!credential?.configured) reasons.push("凭证未配置");
  if (!prices.length) reasons.push("价格未配置");
  return reasons;
}

// nextMappingRouteOrder appends a draft without colliding in the model/mode keyspace.
// 在模型与生成模式的唯一键空间内计算下一个草稿顺序。
export function nextMappingRouteOrder(mappings: ModelProviderMapping[], modelID: number, generationMode: string) {
  const maximum = mappings
    .filter((item) => item.model_id === modelID && item.generation_mode === generationMode)
    .reduce((result, item) => Math.max(result, item.route_order), 0);
  return Math.floor(maximum / 10 + 1) * 10;
}

// isRetiredProviderChannel recognizes additive-migration tombstones without
// teaching the runtime a third channel status.
export function isRetiredProviderChannel(channel: ProviderChannel) {
  try {
    const transport = JSON.parse(channel.transport_config_json || "{}") as { retired?: unknown };
    return transport.retired === true;
  } catch {
    return false;
  }
}
